var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6574 9.90544C10.7068 9.9548 10.7459 10.0134 10.7726 10.0779C10.7993 10.1424 10.8131 10.2115 10.8131 10.2813C10.8131 10.3511 10.7993 10.4202 10.7726 10.4847C10.7459 10.5492 10.7068 10.6078 10.6574 10.6572C10.608 10.7065 10.5494 10.7457 10.485 10.7724C10.4205 10.7991 10.3513 10.8128 10.2815 10.8128C10.2117 10.8128 10.1426 10.7991 10.0781 10.7724C10.0136 10.7457 9.95504 10.7065 9.90569 10.6572L5.5003 6.25111L1.0949 10.6572C0.995221 10.7568 0.86002 10.8128 0.719045 10.8128C0.578071 10.8128 0.44287 10.7568 0.343186 10.6572C0.243502 10.5575 0.1875 10.4223 0.1875 10.2813C0.1875 10.1403 0.243502 10.0051 0.343186 9.90544L4.74924 5.50005L0.343186 1.09466C0.243502 0.994977 0.1875 0.859776 0.1875 0.718801C0.1875 0.577827 0.243502 0.442626 0.343186 0.342942C0.44287 0.243258 0.578071 0.187256 0.719045 0.187256C0.86002 0.187256 0.995221 0.243258 1.0949 0.342942L5.5003 4.749L9.90569 0.342942C10.0054 0.243258 10.1406 0.187256 10.2815 0.187256C10.4225 0.187256 10.5577 0.243258 10.6574 0.342942C10.7571 0.442626 10.8131 0.577827 10.8131 0.718801C10.8131 0.859776 10.7571 0.994977 10.6574 1.09466L6.25135 5.50005L10.6574 9.90544Z",
    fill: "#00242F",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrey);
export default __webpack_public_path__ + "static/media/crossGrey.231a95570ff8dff8ccb13bd0deb06d38.svg";
export { ForwardRef as ReactComponent };